import {fetchBaseQuery} from "@reduxjs/toolkit/query";
import urls from "../utils/constants/urls";

const ProtectedServicesConfig = fetchBaseQuery({
    baseUrl: urls.root_url,
    prepareHeaders: (headers) => {
        const token = localStorage.getItem('accessToken');
        if (token) {
            headers.set('Authorization', `Bearer ${token}`)
            headers.set('Content-Type', 'application/json')
        }
    }
})

export default ProtectedServicesConfig;